(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('AuditoriaAplicacoesPreviasCtrl', AuditoriaAplicacoesPreviasController);

  AuditoriaAplicacoesPreviasController.$inject = [
    '$q',
    '$scope',
    '$rootScope',
    'aplicacoesPrevias',
    'AuditoriaAplicacaoService',
    'ItensEstoqueService',
    'MessagesService',
    'LoadingService',
    '$uibModal',
    '$uibModalStack',
    '$timeout',
    '$location',
    '$routeParams'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function AuditoriaAplicacoesPreviasController($q,
    $scope, $rootScope, aplicacoesPrevias, AuditoriaAplicacaoService,
    ItensEstoqueService, MessagesService, LoadingService, $uibModal,
    $uibModalStack, $timeout, $location, $routeParams) {
    const vm = this;

    //Model
    vm.aplicacoesPrevias = aplicacoesPrevias;

    //////////////////////////////////////////
    // Bindable functions
    vm.approveApplication = approveApplication;
    vm.goToAplicacao = goToAplicacao;
    vm.aplicacaoOptions = aplicacaoOptions;
    vm.close = close;
    vm.formatMomentDate = formatMomentDate;

    //////////////////////////////////////////
    // Function declarations
    function formatMomentDate(date, format = DATE_FORMAT.toUpperCase()) {
      return moment(date).format(format);
    }

    // eslint-disable-next-line max-lines-per-function, complexity, max-lines-per-function
    async function approveApplication($event, aplicacao) {
      try {
        aplicacao.loaderAprove = true;
        await AuditoriaAplicacaoService.aprove(aplicacao);

        if (aplicacao.tipo_operacao_enum === 'operacao_semeadura') {
          const messages = await ItensEstoqueService.checkSaldoSementeBranca(aplicacao.produtos);
          messages && MessagesService.alert(`Atenção: <br>${messages.join('<br>')}`);
        }
        aplicacao.situacao = 'aprovado';
        aplicacao.loaderAprove = false;
        $rootScope.$broadcast(EVENT_RELOAD_NOTIFICATIONS);
        vm.close();
      } catch (error) {
        console.error('Error Message ', error);
        if (error) {
          vm.close();
          let message = 'Falha ao aprovar aplicação, tente novamente.';

          if (_.get(error.data, 'type') === 'CustomException') {
            message = `Falha ao aprovar aplicação: ${_.get(error.data, 'message')}`;
          } else if (_.isArray(error.data) && error.data[0].id) {
            $rootScope.openPreviousApplicationModal(error);
            return;
          } else if (error.data) {
            message = `Falha ao aprovar aplicação: ${error.data}`;
          }
          aplicacao.loaderAprove = false;
          MessagesService.alert(message);
        }
      } finally {
        aplicacao.loaderAprove = false;
        LoadingService.hideLoading();
      }
    }

    function goToAplicacao(aplicacao) {
      vm.close();
      $rootScope.initState = {
        event: 'edicaoAuditoriaAplicacao',
        rightSide: 'edicaoAuditoriaAplicacao',
        params: aplicacao
      };

      if (!$rootScope.currentPropriedade || $rootScope.currentPropriedade.id !== aplicacao.propriedade.id) {
        $rootScope.setPropriedade(aplicacao.propriedade.id);
      }
      $timeout(function() {
        $location
          .path('/propriedade')
          .search({
            ...$routeParams,
            sidebar: 'edicaoAuditoriaAplicacao',
            propriedade: aplicacao.propriedade.id,
            activeAuditoriaAplicacao: aplicacao.id
          });
      });
    }

    function aplicacaoOptions(aplicacao) {
      vm.close();
      $uibModal.open({
        templateUrl: 'views/aplicacoes/fluxo_apropriacao_aplicacao.html',
        controller: 'FluxoApropriacaoAplicacaoCtrl',
        controllerAs: '$apropriacaoModal',
        resolve: {
          aplicacao: aplicacao
        }
      });
    }

    function close() {
      $uibModalStack.dismissAll();
    }
  }
}());
